<template>
  <HeroComponent :smallWidth="true">


    <template v-slot:hero-image>
      <div class="background-banner-referral-page w-100 h-100 d-flex flex-row justify-center">
        <referral-banner-item1 class="h-100 referrals-banner-hero-image-item1"></referral-banner-item1>
        <referral-banner-item2 class="h-100 referrals-banner-hero-image-item2"></referral-banner-item2>
      </div>
    </template>

    <template v-slot:hero-title>
      Invite Your Friends
    </template>

    <template v-slot:hero-subtitle>
      <span>Get 5% more earnings by inviting your friends</span>
    </template>


  </HeroComponent>
</template>



<script setup>

import ReferralBannerItem1 from '@/icons/ReferralBannerItem1.vue';
import ReferralBannerItem2 from '@/icons/ReferralBannerItem2.vue';
import HeroComponent from '@/components/Common/Hero-Component.vue';

</script>
